import Vue from 'vue';
import '@/styles/index.scss'; // global css
import App from './App.vue';
import router from './router/router.js';
import store from './store';
import '@/router/index.js';
// import Config from './config';
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 多语言国际化 无国际化需要 请删除
import i18n from './i18n';
import Rjelement from 'rjelement-components';
Vue.use(Rjelement);

Vue.config.productionTip = false;

Vue.use(Element, {
  size: 'small'
  // Config.ElementSize
});
Vue.config.productionTip = false;

let APPVue = new Vue({
  router,
  i18n, // 多语言国际化, 无国际化需要 请删除
  store,
  render: h => h(App)
}).$mount('#app');

export default APPVue;
